exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-18686cfd] .w-e-text-container {\n  height: 500px !important;\n  /*!important是重点，因为原div是行内样式设置的高度300px*/\n}\n", ""]);

// exports
